import styled from 'styled-components';
import { JobOption } from '../../../model/JobPackage';
import { ButtonSizes, ButtonSubtle } from '../../../styles/button';
import { device } from '../../../styles/device';
import { JobOptionBody, JobOptionFooter, JobOptionHeader } from '../../../styles/jobs/booking';

const JobOptionsContainer = styled.div`
`;
const JobOptionsFootnotes = styled.div`
    p {
        color: ${(props) => props.theme.colors.fontLight};
        font-size: 13px;
        font-weight: 500;
    }
`;

const JobOptionsGrid = styled.div`
    position: relative;
    width: 100%;
    height: auto;
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    grid-template-rows: auto;
    max-width: 1440px;
    align-items: center;
    column-gap: 16px;

    @media ${device.tablet} {
        grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr);
    }
`;

const JobOption = styled.div`
    background: #FFFFFF;
    border: 1px solid #EAEAEA;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 30px;
    padding: 32px;
    height: min-content;
`;

interface Props {
    onChoose: any;
    buttonText: string;
    joboptions: JobOption[];
    footnote?: string;
}

export default function JobCreateOptions({ onChoose, buttonText, joboptions, footnote }: Props) {

    return (
        <JobOptionsContainer>
            <JobOptionsGrid>
                {joboptions.map((option, index) => {
                    return (
                        <JobOption key={"joboption-" + index}>
                            <JobOptionHeader>
                                <div>
                                    <h3>{option.price}€ {option.priceFootnote != null ? '*' : ''}</h3>
                                    <h2>{option.title}</h2>
                                    <h4>{option.duration}</h4>
                                </div>
                                <div>
                                    {option.icon}
                                </div>
                            </JobOptionHeader>
                            <JobOptionBody>
                                {option.items.map((item, index) => <li key={`joboption-${index}`}><span>{item}</span></li>)}
                            </JobOptionBody>
                            <JobOptionFooter>
                                <ButtonSubtle primary size={ButtonSizes.m} onClick={() => onChoose(option.package)}>{buttonText}</ButtonSubtle>
                            </JobOptionFooter>
                        </JobOption>
                    )
                })}
            </JobOptionsGrid>
            {footnote != null &&
                <JobOptionsFootnotes>
                    <p key={footnote}>* {footnote}</p>
                </JobOptionsFootnotes>
            }
        </JobOptionsContainer>
    )
}